import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    this.showTab(0)
  }

  switch(event) {
    event.preventDefault()
    const tabIndex = this.tabTargets.indexOf(event.currentTarget)
    this.showTab(tabIndex)
  }

  showTab(index) {
    this.panelTargets.forEach((panel, i) => {
      if (i === index) {
        panel.classList.remove("hidden")
        panel.classList.add("block")
      } else {
        panel.classList.add("hidden")
        panel.classList.remove("block")
      }
    })

    this.tabTargets.forEach((tab, i) => {
      if (i === index) {
        tab.classList.add("bg-white", "text-slate-900", "shadow-sm")
        tab.classList.remove("text-slate-600")
        tab.setAttribute("aria-selected", "true")
      } else {
        tab.classList.remove("bg-white", "text-slate-900", "shadow-sm")
        tab.classList.add("text-slate-600")
        tab.setAttribute("aria-selected", "false")
      }
    })
  }
}
